import React from 'react'
import './FormErrors.css'

export default function FormErrors({ errors, onClose }) {
  if (!errors || (Array.isArray(errors) && errors.length === 0)) {
    return null
  }

  // Normalizar errores a array
  const errorArray = Array.isArray(errors) ? errors : [errors]

  return (
    <div className="form-errors" role="alert">
      {onClose && (
        <button className="form-errors__close" onClick={onClose} aria-label="Close error message" type="button">
          ×
        </button>
      )}

      {errorArray.length > 1 ? (
        <ul className="form-errors__list">
          {errorArray.map((error, index) => (
            <li key={index} className="form-errors__item">
              {typeof error === 'string' ? error : error.message || 'Unknown error'}
            </li>
          ))}
        </ul>
      ) : (
        <div className="form-errors__single">
          {typeof errorArray[0] === 'string' ? errorArray[0] : errorArray[0].message || 'Unknown error'}
        </div>
      )}
    </div>
  )
}
